import Vue from 'vue'

Vue.directive('focus', {
  bind: function (el) {
    el.focus()
  },

  inserted: function (el) {
    el.focus()
  },

  update: function (el) {
    el.focus()
  }
})



// WEBPACK FOOTER //
// ./src/directives/focus.js